import { render, staticRenderFns } from "./subject_tree.vue?vue&type=template&id=8c6b54ea&scoped=true&"
import script from "./subject_tree.vue?vue&type=script&lang=js&"
export * from "./subject_tree.vue?vue&type=script&lang=js&"
import style0 from "./subject_tree.vue?vue&type=style&index=0&id=8c6b54ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6b54ea",
  null
  
)

export default component.exports